import { lazy, Suspense, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Redirect, Route, Switch } from "react-router-dom";
import { useGlobalContext } from "../../context/globalContext";
import Steps from "../../shared/steps/steps";
import Loader from "../../shared/loaders/simpleLoader";
import { SERVICE_TYPES } from "../../utils/constants/fieldErrors";
import useServiceType from "../../hooks/useServiseType";
import { useIbRegistrationStepsContext } from "../../context/ibRegistrationContext";

const Agreement = lazy(() =>
  import("../../components/ibRegistration/steps/agreement")
);
const Step2 = lazy(() =>
  import("../../components/ibRegistration/steps/step2")
);
const Step3 = lazy(() =>
  import("../../components/ibRegistration/steps/step3")
);
const Step4 = lazy(() =>
  import("../../components/ibRegistration/steps/step4")
);

export function IbRegistrationStepRoutes() {
  const { steps, activeStep, setActiveStep } =
    useIbRegistrationStepsContext();
  const { i18n } = useTranslation();
  const { serviceType } = useServiceType();

  const {
    globalData: { status },
  } = useGlobalContext();
  const isApproved = useMemo(() => status !== "Approved", [status]);

  return (
    <Steps
      steps={steps}
      activeStep={activeStep}
      setActiveStep={setActiveStep}
      hideSteps={serviceType !== SERVICE_TYPES.ibRegistration && true}
    >
      <Suspense fallback={<Loader />}>
        {isApproved ? (
          <Switch>
            <Route
              component={Agreement}
              path={`/ibRegistration/agreement/:mobile?/${i18n.language}`}
            />
            <Route
              component={Step2}
              path={`/ibRegistration/Identomat/${i18n.language}`}
            />
            <Redirect to={`/ibRegistration/agreement/${i18n.language}`} />
          </Switch>
        ) : (
          <Switch>
            <Route component={Step3} path={`/ibRegistration/step/3`} />
            <Route component={Step4} path={`/ibRegistration/step/4`} />
            <Redirect to={`/ibRegistration/step/3`} />
          </Switch>
        )}
      </Suspense>
    </Steps>
  );
}
